import axios from "axios";

import { getToken } from "@/utils/tokenStorage";

const API = "/api";
const cfg = (extra = {}) => ({ headers: { Authorization: `Bearer ${getToken()}` }, ...extra });

export const carregarFluxo = async ({ inicio, fim, agrupar }) =>
  (await axios.get(`${API}/fluxo-caixa`, cfg({ params: { inicio, fim, agrupar } }))).data;
export const gravarSaldo = async (valor, data) => (await axios.put(`${API}/fluxo-caixa/saldo-base`, { valor, data }, cfg())).data;
export const apagarSaldo = async () => axios.delete(`${API}/fluxo-caixa/saldo-base`, cfg());
/** Mesma rota do botão "pago" da tela de Despesas (grava a data de hoje). */
export const marcarPaga = async (id) => axios.patch(`${API}/expenses/${id}/toggle-paid`, {}, cfg());

export function mensagemDeErro(e, padrao) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d) && d[0]?.msg) return d[0].msg;
  return padrao;
}
